module.exports = __webpack_public_path__ + "static/media/ic_add_pointage.8ee4e737.svg";